module.exports = __webpack_public_path__ + "static/media/details-29-image-2.5c30fbad.jpg";